import { render } from "./CategoriesContent.vue?vue&type=template&id=229378c4&ts=true"
import script from "./CategoriesContent.vue?vue&type=script&lang=ts"
export * from "./CategoriesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__